import { render, staticRenderFns } from "./CertificatesTable.vue?vue&type=template&id=57dd0d3a&scoped=true&"
import script from "./CertificatesTable.vue?vue&type=script&lang=js&"
export * from "./CertificatesTable.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesTable.vue?vue&type=style&index=0&id=57dd0d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd0d3a",
  null
  
)

export default component.exports